import { useEffect, useState } from "react";
import { OptionStockDistributionValue } from "./OpticStockDistributionValue";

export function OpticStockDistribution({
  opticList,
  idProductoAlbaran,
  maxStock,
  onStockChange,
}) {
  const [values, setValues] = useState(opticList);
  const [totalStock, setTotalStock] = useState(0);

  const updateValueAtIndex = (index, newValue) => {
    setValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index].stock = newValue;
      return updatedValues;
    });
    setTimeout(() => {
      onStockChange(
        values.map((v, i) => (i === index ? { ...v, stock: newValue } : v)),
        idProductoAlbaran
      );
    }, 0);
  };

  const handleIncValue = (index) => {
    setValues((prevValues) => {
      const updatedValues = [...prevValues];

      updatedValues[index].stock = parseInt(updatedValues[index].stock) + 1;

      setTimeout(() => {
        onStockChange(updatedValues, idProductoAlbaran);
      }, 0);

      return updatedValues;
    });
  };

  const handleDecValue = (index) => {
    setValues((prevValues) => {
      const updatedValues = [...prevValues];

      updatedValues[index].stock = parseInt(updatedValues[index].stock) - 1;

      setTimeout(() => {
        onStockChange(updatedValues, idProductoAlbaran);
      }, 0);

      return updatedValues;
    });
  };

  function handleValue(e, i) {
    let rawValue = e.target.value;

    // Elimina todo lo que no sea dígito
    let cleanedValue = rawValue.replace(/\D/g, "");

    // Si cleanedValue está vacío, establece 0
    const newValue = cleanedValue === "" ? 0 : parseInt(cleanedValue, 10);

    updateValueAtIndex(i, newValue);
  }

  useEffect(() => {
    const sum = values.reduce((acc, e) => {
      const stock = parseInt(e.stock, 10);
      return acc + (Number.isInteger(stock) ? stock : 0);
    }, 0);

    setTotalStock(sum);
  }, [values]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <span>
        Distribución de stock ({totalStock}/{maxStock}):{" "}
        <span className={`${totalStock === maxStock ? "right-c" : "wrong-c"}`}>
          {totalStock === maxStock ? "Correcta" : "Incorrecta"}
        </span>
      </span>
      <div className="optic-item">
        {opticList.map((e, i) => {
          return (
            <OptionStockDistributionValue
              key={i}
              value={values[i].stock}
              opticName={e.nombreOptica}
              onDec={handleDecValue}
              onInc={handleIncValue}
              onChangeValue={(e) => {
                handleValue(e, i);
              }}
              index={i}
              maxStock={maxStock}
            ></OptionStockDistributionValue>
          );
        })}
      </div>
    </div>
  );
}
